import { useEffect } from "react";
import { RouterProvider } from "react-router-dom";
import { clarity } from "react-microsoft-clarity";
import { AinaIntroPrimer } from "./components/aina-intro";
import { router } from "./routes/router";
import { AuthProvider } from "./providers/AuthProvider";
import { MenuNavigationProvider } from "./providers/MenuNavigationProvider";
import { clarityProjectId, isClarityEnabled } from "./lib/clarityIdentity";
import {
  initFormbricks,
  registerFormbricksRouteChange,
  syncFormbricksUserIdentity,
} from "./lib/formbricks";
import { useAuthStore } from "./store/useAuthStore";
import "./App.css";

function App() {
  const profilesData = useAuthStore((state) => state.profilesData);
  const token = useAuthStore((state) => state.token);

  useEffect(() => {
    if (!isClarityEnabled || !clarityProjectId) {
      return;
    }
    clarity.init(clarityProjectId);
  }, []);

  useEffect(() => {
    void (async () => {
      await initFormbricks();
      await registerFormbricksRouteChange();
    })();
  }, []);

  useEffect(() => {
    if (!token) {
      return;
    }
    void syncFormbricksUserIdentity(profilesData);
  }, [token, profilesData]);

  useEffect(() => {
    return router.subscribe(() => {
      void registerFormbricksRouteChange();
    });
  }, []);

  return (
    <AuthProvider>
      <MenuNavigationProvider>
        <AinaIntroPrimer />
        <RouterProvider router={router} />
      </MenuNavigationProvider>
    </AuthProvider>
  );
}

export default App;
